import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { Card } from '../types/Card';

export const cardsApi = createApi({
    reducerPath: 'cardsApi',
    baseQuery: fetchBaseQuery({ baseUrl: 'https://eopi1vgq26.execute-api.us-east-1.amazonaws.com/' }),
    endpoints: (build) => ({
        getCards: build.query<{items: Card[]}, void>({
            query: () => `cards`,
        }),
        createCard: build.mutation<Card, { name: string; imageBase64: string; imageExt: string; imageContentType: string; }>({
            query(body) {
                return {
                    url: `cards`,
                    method: 'POST',
                    body,
                }
            },
        }),
        reportCardClick: build.mutation<void, { id: string; }>({
            query(body) {
                return {
                    url: `cards/click`,
                    method: 'POST',
                    body,
                }
            },
        }),
        updateCard: build.mutation<Card, { id: string;enabled: boolean; }>({
            query(body) {
                return {
                    url: `cards/update`,
                    method: 'POST',
                    body,
                }
            },
        }),
    }),
});

export const { useGetCardsQuery, useCreateCardMutation, useReportCardClickMutation, useUpdateCardMutation } = cardsApi;